import React, { FC } from 'react';
import { useButton, useI18n } from '~Hooks';
import { Box, GreenButton, GhostButton } from '~Styles';
import ErrorNote from '~Components/ErrorNote';

interface Props {
  message: string;
  /** Optional main action, e.g. try again or undo the earlier charge. */
  primary?: { label: string; onClick: () => void };
  onOtherPayment: () => void;
  /** Shows Cancel instead of Other payment, for when the bill may already be on the room. */
  cancelOnly?: boolean;
}

/** A refusal or failure, with a way forward: the main action or another payment method. */
const MessageStep: FC<Props> = ({ message, primary, onOtherPayment, cancelOnly }) => {
  const { i18n } = useI18n();
  const primaryButton = useButton({ onClick: () => primary?.onClick() });
  const otherPaymentButton = useButton({ onClick: onOtherPayment });

  return (
    <Box fluid display="flex" flexDirection="column" gap="medium">
      <ErrorNote>{message}</ErrorNote>

      <Box fluid style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 8 }}>
        <GhostButton {...otherPaymentButton} size="large">
          {i18n(cancelOnly ? 'HotelRoom.Cancel' : 'HotelRoom.OtherPayment')}
        </GhostButton>
        {primary && (
          <GreenButton {...primaryButton} size="large">
            {primary.label}
          </GreenButton>
        )}
      </Box>
    </Box>
  );
};

export default MessageStep;
